import VuexCommonMix from '@/store/vuexCommonMix'
import { queryeGetLoginUrl, queryeCheckLogin, queryeStudentCourse } from '@/api'
export default {
  components: {},
  mixins: [VuexCommonMix],
  props: [],
  name: 'personalDetails-page',
  data () {
    return {
      user: {
        eduStudentId: '',
        gender: '',
        headerUrl: '',
        nickName: '',
        phone: '',
        studentHeaderUrl: '',
        studentNickName: '',
        studentRealName: '',
        userId: '',
        userType: ''
      },
      courseList: []
    }
  },
  created () {
    this.getUseInfo()
  },
  mounted () { },
  destroyed () { },
  methods: {
    async getLoginUrl () {
      const { data } = await queryeGetLoginUrl({ redirect: 'https://gec-api.gecacademy.cn/evaluation/user/wx/callBack?userType=-1' })
      window.location.href = data
    },
    async getUseInfo () {
      const { data } = await queryeCheckLogin()
      this.initUserInfo(data)
      this.user = data
      // 如果已经登录有用户信息
      if (this.user.userId) {
        this.getStudentCourse()
      } else {
        this.getLoginUrl()
      }
    },
    async getStudentCourse () {
      const { data, error } = await queryeStudentCourse()
      if (error.returnCode === 1) {
        // 关闭页面
        setTimeout(() => {
          document.addEventListener(
            'WeixinJSBridgeReady',
            function () {
              window.WeixinJSBridge.call('closeWindow')
            },
            false
          )
          // 苹果
          window.WeixinJSBridge.call('closeWindow')
        }, 1200)
      } else {
        this.courseList = data.courseList
      }
    },
    goProjectList (item) {
      this.$router.push({ path: '/personalProjectList', query: { sellOrderId: item.sellOrderId, classId: item.classId } })
    },
    gettype (item) {
      return item.courseTypeStr && (item.courseTypeStr.indexOf('1v1') > -1 || item.courseTypeStr.indexOf('1V1') > -1)
    },
    gettype1 (item) {
      return item.courseTypeStr && (item.courseTypeStr.indexOf('ipq') > -1 || item.courseTypeStr.indexOf('IPQ') > -1)
    }
  }
}
